import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Kevin Nguyen <kevin@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect } from "react";
import { Outlet, useLocation, useMatch, useNavigate, useParams } from "react-router-dom";
export default function TenantEvent() {
    var navigate = useNavigate();
    var params = useParams();
    var location = useLocation();
    var noMatch = useMatch("/tenant/:tenantId/event/:eventId/");
    var path = "/tenant/".concat(params.tenantId, "/event/").concat(params.eventId, "/election-chooser").concat(location.search);
    useEffect(function () {
        if (noMatch) {
            navigate(path);
        }
    }, [navigate, params, noMatch, path]);
    return _jsx(Outlet, {});
}
